import { render, staticRenderFns } from "./AmbulanciasServiciosEspeciales.vue?vue&type=template&id=015caa86"
import script from "./AmbulanciasServiciosEspeciales.vue?vue&type=script&lang=js"
export * from "./AmbulanciasServiciosEspeciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports